<template>
  <div v-if="loading">
    <v-flex offset-xs5 pa-5>
      <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
    </v-flex>
  </div>
  <div v-else>
    <DataTable :headers="headers" :path="path" actionButtonsName="InformesListActionButtons" :properties="properties"
    filter :filterPath="filterPath">
    </DataTable>
  </div>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'

export default {
  components: {
    DataTable
  },
  props: {
    path: String
  },
  data () {
    return {
      filterPath: 'filters/informes'
    }
  },
  computed: {
    loading () {
      return false
    },
    headers () {
      let headers = [
        { text: 'Temporada', value: 'temporada.pk', align: 'left' },
        { text: 'Período', value: 'mes' },
        { text: 'Presentado', value: 'fechaPresentado' },
        { text: 'Vencimiento', value: 'fechaVencimiento' },
        { text: 'Estado', value: 'estado', filterField: true },
        { text: 'Acciones', align: 'right', sortable: false }
      ]
      if (this.$store.getters.isSafRole) {
        headers.splice(4, 0, { text: 'Club', value: 'club', filterField: true })
      }
      return headers
    },
    properties () {
      const propiedades = ['temporada.nombre', 'mesDisplay', 'fechaPresentado', 'fechaVencimiento', 'estadoDisplay']
      if (this.$store.getters.isSafRole) {
        propiedades.splice(4, 0, 'club.nombre')
      }
      return propiedades
    }
  }
}
</script>
